// removed by extract-text-webpack-plugin
module.exports = {"Tag":"src-components-Tag----Tag-module---Tag---nFUgo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tag/Tag.module.css
// module id = 138
// module chunks = 35783957827783 213720915766396